import { render, staticRenderFns } from "./modal-details.vue?vue&type=template&id=4e310743&scoped=true&"
import script from "./modal-details.vue?vue&type=script&lang=js&"
export * from "./modal-details.vue?vue&type=script&lang=js&"
import style0 from "./modal-details.vue?vue&type=style&index=0&id=4e310743&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e310743",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e310743')) {
      api.createRecord('4e310743', component.options)
    } else {
      api.reload('4e310743', component.options)
    }
    module.hot.accept("./modal-details.vue?vue&type=template&id=4e310743&scoped=true&", function () {
      api.rerender('4e310743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/modals/modal-details.vue"
export default component.exports